import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=2a4de11f&scoped=true&"
import script from "./ListItem.vue?vue&type=script&lang=js&"
export * from "./ListItem.vue?vue&type=script&lang=js&"
import style0 from "./ListItem.vue?vue&type=style&index=0&id=2a4de11f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4de11f",
  null
  
)

export default component.exports